import { render, staticRenderFns } from "./ProStatAlert.vue?vue&type=template&id=647393df&scoped=true"
import script from "./ProStatAlert.vue?vue&type=script&lang=js"
export * from "./ProStatAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647393df",
  null
  
)

export default component.exports